import PriceWithCrossedDiscount from './PromoCodesSummaryItems/PriceWithCrossedDiscount/PriceWithCrossedDiscount'
import { getAppliedDiscounts } from '../OrderSummaryUtils'
import { translateManager as t } from 'services/TranslateManager'
import { getSizeName } from '../../../../services/SizesManager'
import { TILE_SIZES } from '@mixtiles/web-backend-shared'

function CenterpiecesSummaryItem({ data, woodPricingEnabled }) {
  const {
    currency,
    centerpiecesTotalPrice,
    centerpiecesDiscount,
    centerpiecesCount,
  } = data
  if (centerpiecesCount === 0) {
    return null
  }
  const { discountDesc } = getAppliedDiscounts(data, false)

  let description =
    centerpiecesCount === 1
      ? `1 ${t.get(
          'order.checkout.payment_summary_rows.wall_sign'
        )}, ${getSizeName(TILE_SIZES.RECTANGLE_25X8)}`
      : `${centerpiecesCount} ${t.get(
          'order.checkout.payment_summary_rows.wall_signs'
        )}, ${getSizeName(TILE_SIZES.RECTANGLE_25X8)}`

  return (
    <PriceWithCrossedDiscount
      description={description}
      detailedDescription={
        discountDesc?.length && !woodPricingEnabled
          ? { title: discountDesc }
          : undefined
      }
      priceBeforeDiscount={centerpiecesTotalPrice}
      priceAfterDiscount={centerpiecesTotalPrice - centerpiecesDiscount}
      currency={currency}
    />
  )
}

export default CenterpiecesSummaryItem
